
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value || 0);
};

export const formatDate = (dateString: string): string => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString.includes('T') ? dateString : dateString + 'T12:00:00');
    if (isNaN(date.getTime())) return 'Data Inválida';
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: 'short',
    }).format(date);
  } catch (e) {
    return 'Erro Data';
  }
};

export const parseCurrencyToNumber = (value: string): number => {
  if (!value) return 0;
  const cleanValue = value.replace(/[^\d]/g, '');
  return parseFloat(cleanValue) / 100;
};

export const maskCurrency = (value: string | number): string => {
  const cleanValue = typeof value === 'number' 
    ? (value * 100).toFixed(0).toString()
    : value.replace(/[^\d]/g, '');
    
  if (!cleanValue || cleanValue === 'NaN') return '0,00';
  
  const numericValue = parseInt(cleanValue, 10) / 100;
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue);
};

let serverTimeOffset = 0;

export const setServerTimeOffset = (serverTimeStr: string) => {
  if (!serverTimeStr) return;
  const serverTime = new Date(serverTimeStr).getTime();
  if (isNaN(serverTime)) return;
  serverTimeOffset = serverTime - Date.now();
};

export const getTrustedDate = (): Date => {
  const adjustedTime = Date.now() + serverTimeOffset;
  return isNaN(adjustedTime) ? new Date() : new Date(adjustedTime);
};

export const getAvatarUrl = (name?: string): string => {
  if (!name) return 'https://ui-avatars.com/api/?name=User&background=random';
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=0f172a&color=fff&size=128&bold=true`;
};
